import React from 'react';
import Pitch from '../../Pitch';
import { IGameModelSimulation } from '../../../types/IClubDetail';

interface GameModelVisualizationProps {
    gameModelData: IGameModelSimulation | null;
    swapHistoryLength: number;
    teamId: number;
    setSidebarPlayerShow: React.Dispatch<React.SetStateAction<boolean>>;
    isPerformancSwitchToggled: boolean;
    setPlayerCardID: React.Dispatch<React.SetStateAction<number>>;
}

export const GameModelVisualization: React.FC<GameModelVisualizationProps> = ({
    gameModelData,
    swapHistoryLength,
    teamId,
    setSidebarPlayerShow,
    isPerformancSwitchToggled,
    setPlayerCardID
}) => {
    // When there's no swap history, show single view
    if (swapHistoryLength === 0) {
        return (
            <div className="pitch-container-for-pdf">
                <Pitch
                    currentView="GameModel"
                    selectedTeam={teamId}
                    gameModelData={gameModelData?.inGameModel}
                    gameModelPlayers={gameModelData?.inPlayersDetail}
                    selectedMatch={0}
                    isForSimulation={true}
                    isVerticalGameModel={false}
                    setSidebarPlayerShow={setSidebarPlayerShow}
                    setPlayerCardID={setPlayerCardID}
                    isPerformancSwitchToggled={isPerformancSwitchToggled}
                />
            </div>
        );
    }

    // When there's swap history, show side-by-side view
    return (
       <div className="pitch-container-for-pdf">
                {/* Out Game Model (Left Side) */}
            <div style={{ display: 'flex', width: '100%', alignItems: 'center', height: '600px', justifyContent: 'center', marginTop: '40px' }}>

                <div style={{ width: '800px', height: '430px' }}>
                    <Pitch
                        currentView="GameModel"
                        selectedTeam={teamId}
                        gameModelData={gameModelData?.outGameModel}
                        gameModelPlayers={gameModelData?.outPlayersDetail}
                        selectedMatch={0}
                        isForSimulation={true}
                        isVerticalGameModel={true}
                        setSidebarPlayerShow={setSidebarPlayerShow}
                        setPlayerCardID={setPlayerCardID}
                        isPerformancSwitchToggled={isPerformancSwitchToggled}
                    />
                </div>

                {/* In Game Model (Right Side) */}
                <div style={{ width: '800px', height: '430px', marginLeft: '-200px' }}>
                    <Pitch
                        currentView="GameModel"
                        selectedTeam={teamId}
                        gameModelData={gameModelData?.inGameModel}
                        gameModelPlayers={gameModelData?.inPlayersDetail}
                        selectedMatch={0}
                        isForSimulation={true}
                        isVerticalGameModel={true}
                        setSidebarPlayerShow={setSidebarPlayerShow}
                        setPlayerCardID={setPlayerCardID}
                        isPerformancSwitchToggled={isPerformancSwitchToggled}
                    />
                </div>
            </div>
        </div>
    );
};

export default GameModelVisualization;